import { useQuery } from "@tanstack/react-query";
import type { Link } from "@/lib/schemas/paycode/link";
import { useCheckoutStore } from "../store/checkout";

type Status = "loading" | "error" | "ready";

export function usePaymentLink(hash: string) {
  const loadLink = useCheckoutStore((s) => s.loadLink);

  const { data, error, status, refetch } = useQuery({
    queryKey: ["payment-link", hash],
    queryFn: async (): Promise<Link> => {
      const response = await fetch("/api/session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ hash }),
      });
      const data = await response.json();

      if (!response.ok || data.error) {
        throw new Error(data.error ?? "Failed to load checkout");
      }

      loadLink(data.link);

      return data.link;
    },
    enabled: !!hash,
  });

  const mappedStatus: Status =
    status === "pending" ? "loading" : status === "error" ? "error" : "ready";

  return {
    link: data ?? null,
    error: error ? error.message : null,
    status: mappedStatus,
    refetch,
  };
}
